import axios from "axios";
import { API_BASE_URL } from "../environment";

const tenantParams = () => {
  const user = JSON.parse(sessionStorage.getItem("info") || "{}");
  return { user_id: user.id, user_type: user.type };
};

export const getFileChargeRules = async () =>
  (await axios.get(`${API_BASE_URL}/file-charge-rules/`, { params: tenantParams() })).data;

export const createFileChargeRule = async (data: object) =>
  (await axios.post(`${API_BASE_URL}/file-charge-rules/`, { ...data, ...tenantParams() })).data;

export const updateFileChargeRule = async (id: number, data: object) =>
  (await axios.put(`${API_BASE_URL}/file-charge-rules/${id}`, { ...data, ...tenantParams() })).data;

export const deleteFileChargeRule = async (id: number) =>
  (await axios.delete(`${API_BASE_URL}/file-charge-rules/${id}`, { params: tenantParams() })).data;

export const calculateFileCharge = async (amount: number, numberOfEmis?: number) =>
  (await axios.get(`${API_BASE_URL}/file-charge-rules/calculate`, { params: { amount, numberOfEmis, ...tenantParams() } })).data;
